<template>
    <div v-if="renderComponent">
        <div v-if="$store.state.inClientAdmin" v-show="$store.state.loginSession15MinLeft <= 900">
            <span style="color:#c82333">{{ $helper.trans('Session_time_left') }}: {{ $store.state.loginSessionTimeLeft }}</span>
            <button class="position-absolute btn btn-danger btn-sm ml-2" @click="$helper.extendSession()">
                {{ $helper.trans('Extend_session') }}
            </button>
        </div>
        <div class="container height-100 py-2" v-if="!inClientAdmin">
            <button class="position-absolute btn btn-secondary btn-sm" @click="logState()" v-if="$store.state.$siteSettings['debug']">
                DEBUG Log State
            </button>
            <div 
                :class="{
                    'header-calculation-wrap': ['initial', 'senderServiceSelector'].includes($store.state.calculatorState), 
                    'wrapper': ['shippingInformationForm', 'payment'].includes($store.state.calculatorState)
                }"
            >
                <initial-calculator-text
                    :initial-left-text="initialLeftText"
                    v-if="$store.state.calculatorState === 'initial' && !noSideText"
                />
    
                <initial-calculator-form
                    v-if="$store.state.calculatorState === 'initial'"
                    :no-side-text="noSideText"
                />
    
                <sender-service-selector
                    v-if="$store.state.calculatorState === 'senderServiceSelector'"
                    :initialSelect="true"
                />
    
                <shipping-information-form
                    v-if="$store.state.calculatorState === 'shippingInformationForm'"
                />

                <payment-component
                    v-if="$store.state.calculatorState === 'payment'"
                />
            </div>
            <address-selector-modal></address-selector-modal>
        </div>
        <div class="content-wrap" v-else>          
            <button class="btn-secondary btn-sm mb-2" @click="logState()" v-if="$store.state.$siteSettings['debug']">
                DEBUG Log State
            </button>
            <div class="import-export-buttons py-1" v-if="$store.state.calculatorState !== 'payment'">
                <button v-if="$store.state.selectedFormType === 'single'"
                    class="btn mr-1" :class="{'selected': $store.state.selectedShippingType === 'export'}" 
                    @click="$store.state.selectedShippingType = 'export'">{{ $helper.trans('Ready_package_export_button') }}</button>
                
                <button v-if="$store.state.selectedFormType === 'single'"
                    class="btn" :class="{'selected': $store.state.selectedShippingType === 'import'}" 
                    @click="$store.state.selectedShippingType = 'import'">{{ $helper.trans('Ready_package_import_button') }}</button>               
                
                <button style="margin-bottom:4px;"
                    v-if="$store.state.$siteSettings.customer_payment_type === 'all'"
                    class="btn float-right massButton" :class="{'selected': $store.state.selectedFormType === 'mass'}" 
                    @click="changeFormType();">
                    {{ $helper.trans('Mass_import_button') }}
                </button>                
            </div>
            <div v-if="$store.state.calculatorState !== 'payment'">
                <address-selector-modal></address-selector-modal>
                
                <shipper-address-block></shipper-address-block>
    
                <delivery-address-block></delivery-address-block>
    
                <package-block v-if="$store.state.selectedFormType === 'single'"></package-block>
    
                <shipping-option-block v-if="$store.state.selectedFormType === 'single'"></shipping-option-block>
            
                <shipping-information-block></shipping-information-block>
    
                <fourth-step-information-block></fourth-step-information-block>
                
                <other-payment-options-block v-if="$store.state.$siteSettings.customer_payment_type === 'all'"></other-payment-options-block>

                <div class="send-block button-block" style="justify-content: space-between;">
                    <button class="btn btn-yellow radius-4" :disabled="requestInProgress" @click="createShipmentDraft();">
                        <i v-if="requestInProgress" class="fa fa-spinner fa-spin"></i>
                        {{ $helper.trans('Continue') }}
                    </button>
                    <button class="btn btn-white radius-4 draft-button" :disabled="requestInProgress" @click="createOrderDraft();">
                        {{ $helper.trans('Save_draft') }}
                    </button>
                </div>
            </div>

            <payment-component
                v-if="$store.state.calculatorState === 'payment'"
            />
        </div>
     
        <commercial-invoice-modal v-if="$store.state.selectedFormType === 'single'"></commercial-invoice-modal>
        <mass-shipments-commercial-invoice-modal v-if="$store.state.selectedFormType === 'mass'"></mass-shipments-commercial-invoice-modal>

        <div class="modal fade" id="forbidden_items_modal" tabindex="-1" role="dialog" aria-labelledby="forbidden_items_modalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="forbidden_items_modalLabel">{{ $helper.trans('Prohibited_items_list') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-html="$store.state.$siteSettings['Forbidden_items_list']"></div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-warning" data-dismiss="modal">{{ $helper.trans('Close') }}</button>      
                </div>
                </div>
            </div>
        </div>
        <div id="toast_container" style="z-index: 1100;"></div>

        <!-- Modal -->
        <div class="modal fade" id="sessionExpiredModal" tabindex="-1" aria-labelledby="sessionExpiredModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="sessionExpiredModalLabel">{{ $helper.trans('Session_expired') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        {{ $helper.trans('If_you_want_continue_please_login_again') }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $helper.trans('Close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../store";
export default {
    store,
    data: function() {
        return {
            countriesList: {},
            initialLeftText: {},
            renderComponent: true,
            phoneRegex: new RegExp(/[a-zą-ž]/gi),
            requestInProgress: false,
        }
    },
    props: {
        countriesListJson: {
            type: String,
            required: true,
        },
        initialLeftTextJson: {
            type: String,
            required: true,
        },
        routesJson: {
            type: String,
            required: true,
        },
        siteSettingsJson: {
            type: String,
            required: true,
        },
        inClientAdmin:{
            type: Boolean,
            required: false,
            default: false,
        },
        userAddressesJson: {
            type: String,
            required: true,
        },
        userSettingsJson: {
            type: String,
            required: true,
        },
        calculatorDataJson: {
            type: String,
            required: false,
            default: '',
        },
        lockedToCountry: {
            validator: function (value) {
                return typeof value === 'string' || value === false;
            },
            required: false,
            default: false,
        },
        noSideText: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    created: function() {
        let vueThis = this;
    
        vueThis.$store.state.sessionStartTime = vueThis.$helper.getSessionStartTime();   

        if (vueThis.calculatorDataJson !== '') {
            vueThis.$store.state.copied = true;            
            let calculatorData = JSON.parse(Base64.decode(vueThis.calculatorDataJson));  
          
            $.each(calculatorData, function(index, element) {
                vueThis.$store.state[index] = structuredClone(element);
            });
        }
        
        vueThis.$store.state.inClientAdmin = vueThis.inClientAdmin;
        vueThis.$store.state.countriesList = JSON.parse(Base64.decode(vueThis.countriesListJson));
        vueThis.initialLeftText = JSON.parse(Base64.decode(vueThis.initialLeftTextJson));
        vueThis.$store.state.$routes = JSON.parse(Base64.decode(vueThis.routesJson));
        vueThis.$store.state.$siteSettings = JSON.parse(Base64.decode(vueThis.siteSettingsJson));
        vueThis.$store.state.userAddresses = JSON.parse(Base64.decode(vueThis.userAddressesJson));
        vueThis.$store.state.userSettings = JSON.parse(Base64.decode(vueThis.userSettingsJson)).user_settings;

        if (vueThis.$store.state.$siteSettings['Logged_in']) {
            vueThis.$store.state.loggedInUser = true;
        }

        if (vueThis.$store.state.inClientAdmin) {
           vueThis.$helper.checkLoginSessionExpiry();
           vueThis.$store.state.sessionChecker = setInterval(() => {
               vueThis.$helper.checkLoginSessionExpiry();
           }, 10000);
        }
        
        if (!vueThis.$store.state.copied) {
            let countrySelected = false;
            $.each(vueThis.$store.state.countriesList, function(index, element) {
                if (!countrySelected && element.country_code.toLowerCase() === 'lt') {
                    vueThis.$store.state.from.countryId = index;
                    vueThis.$store.state.from.countryBackgroundImage = element.backgroundImage;
                    vueThis.$store.state.from.countryName = element.title;
    
                    countrySelected = true;
                }
            });      
        } else {
            if (vueThis.$store.state.to.countryId === undefined) {
                let toCountrySelected = false;
                $.each(vueThis.$store.state.countriesList, function(index, element) {
                    if (!toCountrySelected && element.country_code.toLowerCase() === vueThis.$store.state.to.country) {
                        vueThis.$store.state.to.countryId = index;
                        vueThis.$store.state.to.countryBackgroundImage = element.backgroundImage;
        
                        toCountrySelected = true;
                    }
                });   
            }
        }
   
        vueThis.$store.state.carrierInfo.carrierDate = moment().format('YYYY-MM-DD');
        
        if (vueThis.$store.state.$siteSettings.customer_payment_type !== 'prepaid') {
            vueThis.$store.state.majorPaymentType = vueThis.$store.state.$siteSettings.customer_payment_type;
        }

        if (vueThis.inClientAdmin) {
            vueThis.$nextTick(function() {
                setTimeout(function() {
                    vueThis.$helper.toggleAccordion(vueThis.$store.state.currentLevel, false, false, vueThis.$store.state.inClientAdmin ? -42 : 0);
                }, 250);
            });
        }

        if (vueThis.$store.state.copied) { 
            vueThis.$store.state.majorPaymentType = vueThis.$store.state.$siteSettings.customer_payment_type;

            vueThis.$store.state.selectedFormType = 'single';
            if (vueThis.$store.state.direction === 'I') {
                vueThis.$store.state.selectedShippingType = 'import';
            }          
            return;
        }      
        
        if (vueThis.$store.state.userSettings.default_description !== undefined && vueThis.$store.state.userSettings.default_description != null) {
            vueThis.$store.state.otherDeliveryInformation.description = vueThis.$store.state.userSettings.default_description;
        }         

        if (vueThis.$store.state.userSettings.required_signatare !== undefined && vueThis.$store.state.userSettings.required_signatare !== null) {
            vueThis.$store.state.otherDeliveryInformation.requireSignature = vueThis.$store.state.userSettings.required_signatare;
        }

        if (vueThis.$store.state.userSettings.only_direct_delivery !== undefined && vueThis.$store.state.userSettings.only_direct_delivery !== null) {
            vueThis.$store.state.otherDeliveryInformation.directDelivery = vueThis.$store.state.userSettings.only_direct_delivery;
        }

        if (vueThis.$store.state.userSettings.cod !== undefined && vueThis.$store.state.userSettings.cod !== null) {
            vueThis.$store.state.otherDeliveryInformation.cashOnDelivery = vueThis.$store.state.userSettings.cod;
        }

        if (vueThis.$store.state.userSettings.adult_signature !== undefined && vueThis.$store.state.userSettings.adult_signature !== null) {
            vueThis.$store.state.otherDeliveryInformation.adultSignature = vueThis.$store.state.userSettings.adult_signature;
        }

        if (vueThis.$store.state.transportationType = 'export') {        
            if (
                vueThis.$store.state.$siteSettings.isc_bio && 
                vueThis.$store.state.userSettings.isc_bio !== undefined && 
                vueThis.$store.state.userSettings.isc_bio !== null
            ) {
                vueThis.$store.state.otherDeliveryInformation.iscBio = vueThis.$store.state.userSettings.isc_bio;
            }

            if (
                vueThis.$store.state.$siteSettings.isc_other && 
                vueThis.$store.state.userSettings.isc_other !== undefined && 
                vueThis.$store.state.userSettings.isc_other !== null
            ) {
                vueThis.$store.state.otherDeliveryInformation.iscOther = vueThis.$store.state.userSettings.isc_other;
            }
        }

        if (vueThis.$store.state.userSettings.delivery_conditions !== undefined && vueThis.$store.state.userSettings.delivery_conditions !== null) {
            vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCondition = vueThis.$store.state.userSettings.delivery_conditions.toLowerCase();
        }

        if (vueThis.$store.state.userSettings.export_reasons !== undefined && vueThis.$store.state.userSettings.export_reasons !== null) {
            vueThis.$store.state.commercialInvoiceModal.commercialInvoiceExportReason = vueThis.$store.state.userSettings.export_reasons.toLowerCase();
        }

        if (vueThis.$store.state.userSettings.currency !== undefined && vueThis.$store.state.userSettings.currency !== null) {
            vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCurrency = vueThis.$store.state.userSettings.currency.toLowerCase();
        }

        if (vueThis.$store.state.userSettings.declaration !== undefined && vueThis.$store.state.userSettings.declaration !== null) {
            vueThis.$store.state.commercialInvoiceModal.declaration = vueThis.$store.state.userSettings.declaration.toLowerCase();
        }

        if (vueThis.$store.state.userSettings.voec !== undefined && vueThis.$store.state.userSettings.voec !== null) {
            vueThis.$store.state.otherDeliveryInformation.voecVatRegistration = vueThis.$store.state.userSettings.voec;
        }

        if (vueThis.$store.state.userSettings.pva !== undefined && vueThis.$store.state.userSettings.pva !== null) {
            vueThis.$store.state.otherDeliveryInformation.pvaRegistration = vueThis.$store.state.userSettings.pva;
        }

        this.calculateTransportationType();
        
        if (!empty(vueThis.$store.state.countriesList[vueThis.lockedToCountry])) {
            vueThis.$store.state.to.countryId = vueThis.lockedToCountry;
            vueThis.$store.state.to.country = vueThis.$store.state.countriesList[vueThis.lockedToCountry].country_code.toLowerCase();
            vueThis.$store.state.to.countryBackgroundImage = vueThis.$store.state.countriesList[vueThis.lockedToCountry].backgroundImage;
            vueThis.$store.state.to.countryName = vueThis.$store.state.countriesList[vueThis.lockedToCountry].title;
            vueThis.$store.state.customValues.lockedToCountry = true;
        }

        if (vueThis.$store.state.userSettings.notifications == undefined) {
            return;
        }
           
        vueThis.$store.state.otherDeliveryInformation.notifications = vueThis.$store.state.userSettings.notifications;
        

        if (vueThis.$store.state.userSettings.sender_about_parcel !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.senderAboutParcelEmail = true;
        }

        if (vueThis.$store.state.userSettings.sender_about_exceptions !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.senderAboutExceptionsEmail = true;
        }

        if (vueThis.$store.state.userSettings.sender_about_parcel_delivery !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.senderAboutParcelDeliveryEmail = true;
        }

        if (vueThis.$store.state.userSettings.receiver_about_parcel !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.receiverAboutParcelEmail = true;
        }

        if (vueThis.$store.state.userSettings.receiver_about_exceptions !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.receiverAboutExceptionsEmail = true;
        }

        if (vueThis.$store.state.userSettings.receiver_about_parcel_delivery !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.receiverAboutParcelDeliveryEmail = true;
        }
        
        if (vueThis.$store.state.userSettings.other_about_parcel !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.otherAboutParcelEmail = true;
        }

        if (vueThis.$store.state.userSettings.other_about_exceptions !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.otherAboutExceptionsEmail = true;
        }

        if (vueThis.$store.state.userSettings.other_about_parcel_delivery !== undefined) {
            vueThis.$store.state.otherDeliveryInformation.otherAboutParcelDeliveryEmail = true;
        }

        if (vueThis.$store.state.userSettings.notification_other !== undefined) {            
            vueThis.$store.state.otherDeliveryInformation.otherNotificationsEmail = vueThis.$store.state.userSettings.notification_other;
        }      
    },
    methods: {
        createOrderDraft: async function() {             
            await this.$helper.createOrderDraft();

            $('.draft-button').prop('disabled', true);     
            $('.draft-button').addClass('success');         
            $('.draft-button').text(`${this.$helper.trans('Draft_saved')}`);
            $('.draft-button').prop('disabled', false);      

            setTimeout(() => {                  
                $('.draft-button').removeClass('success');         
                $('.draft-button').text(`${this.$helper.trans('Save_draft')}`);
            }, 2000);
        },
        logState: function() {
            let log_info = structuredClone(this.$store.state);
            delete log_info.$routes;
            delete log_info.countriesList;
            delete log_info.$siteSettings;
            delete log_info.userAddresses;
            log_info.copied = true;
            console.log(JSON.stringify(log_info));
        },
        calculateTransportationType: function() {
            if (this.$store.state.from.country === 'lt') {
                this.$store.state.transportationType = 'export';
            } else {
                this.$store.state.transportationType = 'import';
            }
        },
        createShipmentDraft: async function() {
            this.requestInProgress = true;
            await this.$helper.validateAllFieldsAndCreateOrder();
            this.requestInProgress = false;
        },
        getSelectedCountryCities: function(direction) {
            let vueThis = this;
            if (!vueThis.$helper.needsCity()[direction]) {
                vueThis.$store.state.computed.citiesArray[direction] = [];
                return;
            }

            let url = vueThis.$store.state.$routes['api.get_cities_for_country'];
            let data = {
                params: {
                    'country_code': vueThis.$store.state[direction].country
                }
            };
            axios.get(url, data)
            .then(function(response) {
                if (direction === 'to' && !response.data.includes(vueThis.$store.state.deliveryAddressInformation.city)) {
                    vueThis.$store.state.deliveryAddressInformation.city = '';
                    $('#deliveryCitySelect2').val('').trigger('change.select2');
                } else if (direction === 'from' && !response.data.includes(vueThis.$store.state.shipperAddressInformation.city)) {
                    vueThis.$store.state.shipperAddressInformation.city = '';
                    $('#shipperCitySelect2').val('').trigger('change.select2');
                }

                vueThis.$store.state.computed.citiesArray[direction] = response.data;
            }).catch(function(error) {
                vueThis.$store.state.computed.citiesArray[direction] = [];
                console.error(error);
            });
        },
        changeFormType: function() {
            this.$store.state.selectedShippingType === 'export'    

            if (this.$store.state.selectedFormType === 'single') {
                this.$store.state.selectedFormType = 'mass'
                $('.massButton').text(this.$helper.trans('Single_import_button'));      
            } else if (this.$store.state.selectedFormType === 'mass') {
                $('.massButton').text(this.$helper.trans('Mass_import_button'));
                this.$store.state.selectedFormType = 'single'                
            }
 
            this.$helper.toggleAccordion(2, false, true);

            if (this.$store.state.selectedFormType === 'mass') {
                this.$store.state.otherDeliveryInformation.description = ' .';
            } else {
                this.$store.state.otherDeliveryInformation.description = '';
                if (this.$store.state.userSettings.default_description !== undefined && this.$store.state.userSettings.default_description != null) {
                    this.$store.state.otherDeliveryInformation.description = this.$store.state.userSettings.default_description;
                } 
            }
        }
    },

    watch: {
        '$store.state.from.postCode': function() {
            this.$store.state.awaitingActions.resetShippings = true;
        },
        '$store.state.to.postCode': function() {
            if (this.$store.state.to.country === 'ma') {
                return;
            }

            this.$store.state.awaitingActions.resetShippings = true;
        },
        '$store.state.awaitingActions.resetShippings': function() {
            if (this.$store.state.awaitingActions.resetShippings === false) {
                return;
            }
            this.$store.state.awaitingActions.resetShippings = false;
            
            this.$store.state.availableShippingOptions = [];
            this.$store.state.selectedShippingOption = [];
            this.$store.state.awaitingActions.shippingOptionsWereReset = true;
        },
        '$store.state.shipperAddressInformation.phone': function() {
            let phone = this.$store.state.shipperAddressInformation.phone;
            if (phone && this.phoneRegex.test(phone)) {
                this.$store.state.shipperAddressInformation.phone = phone.replaceAll(this.phoneRegex, '');
            }
        },
        '$store.state.deliveryAddressInformation.phone': function() {
            let phone = this.$store.state.deliveryAddressInformation.phone;
            if (phone && this.phoneRegex.test(phone)) {
                this.$store.state.deliveryAddressInformation.phone = phone.replaceAll(this.phoneRegex, '');
            }
        },
        '$store.state.commercialInvoiceModal.differentAddress.phone': function() {
            let phone = this.$store.state.commercialInvoiceModal.differentAddress.phone;
            if (phone && this.phoneRegex.test(phone)) {
                this.$store.state.commercialInvoiceModal.differentAddress.phone = phone.replaceAll(this.phoneRegex, '');
            }
        },
        '$store.state.otherDeliveryInformation.isDocuments': function(newValue, oldValue) {
            let vueThis = this;
            if (newValue) {
                this.$store.state.otherDeliveryInformation.hasBatteries = false
                vueThis.$store.state.otherDeliveryInformation.description = 'DOCUMENTS';
                $.each(vueThis.$store.state.packagesDimensions, function(index, element) {
                    vueThis.$store.state.packagesDimensions[index].insurance = '';
                });
                vueThis.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
                vueThis.$store.state.otherDeliveryInformation.packageValueDiff = 0;
            } else if (!newValue && !this.$store.state.otherDeliveryInformation.hasBatteries) {
                vueThis.$store.state.otherDeliveryInformation.description = '';
            }
        },
        '$store.state.otherDeliveryInformation.hasBatteries': function(newValue) {
            if (newValue) {
                this.$store.state.otherDeliveryInformation.isDocuments = false
                this.$store.state.otherDeliveryInformation.description = 'Li-ion sII PI966.';
            } else if (!newValue && !this.$store.state.otherDeliveryInformation.isDocuments) {
                this.$store.state.otherDeliveryInformation.description = '';
            }
        },
        '$store.state.shipperAddressInformation.city': function() {
            if (this.$helper.needsCity().from) {
                this.$store.state.awaitingActions.resetShippings = true;
            }
        },
        '$store.state.deliveryAddressInformation.city': function() {
            if (this.$helper.needsCity().to) {
                this.$store.state.awaitingActions.resetShippings = true;
            }
        },
        '$store.state.packageType': function(newValue, oldValue) {
            if (newValue === '01') {
                this.$store.state.otherDeliveryInformation.isDocuments = 1;
            }
            if (oldValue !== '01') {
                this.$store.state.awaitingActions.resetShippings = true;
            }
            this.$forceUpdate();
        }, 
        '$store.state.from.country': function() {
            this.$store.state.from.countryId = this.$store.state.from.countryId.replace("_en", "");
            this.$store.state.from.countryName = this.$store.state.countriesList[this.$store.state.from.countryId].text;
            
            if (this.$store.state.inClientAdmin) {
                this.$helper.validatePostCode(this.$store.state.from.postCode, this.$store.state.from.country, 'post_code_shipper_block');
            } else {
                this.$helper.validatePostCode(this.$store.state.from.postCode, this.$store.state.from.country, 'post_code_from');
            }

            if (this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.insideEu()) {
                this.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
            }
            this.calculateTransportationType();
            this.getSelectedCountryCities('from');
        },
        '$store.state.to.country': function() {
            this.$store.state.to.countryId = this.$store.state.to.countryId.replace("_en", "");
            this.$store.state.to.countryName = this.$store.state.countriesList[this.$store.state.to.countryId].text;

            if (this.$store.state.inClientAdmin) {
                this.$helper.validatePostCode(this.$store.state.to.postCode, this.$store.state.to.country, 'post_code_delivery_block');
            } else {
                this.$helper.validatePostCode(this.$store.state.to.postCode, this.$store.state.to.country, 'post_code_to');
            }

            if (this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.insideEu()) {
                this.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
            }
            this.calculateTransportationType();
            this.getSelectedCountryCities('to');
        },
        '$store.state.selectedShippingType': function() {
            let vueThis = this;
            vueThis.$store.state.defaultAddressSelector = true;
            if (vueThis.$store.state.copied && vueThis.$store.state.direction === 'I') {
                vueThis.$store.state.copied = false;
                return;
            }
            
            let from = vueThis.$store.state.from;
            vueThis.$store.state.from = vueThis.$store.state.to;
            vueThis.$store.state.to = from;

            if (vueThis.$store.state.shippingTabLevel >= 4) {
                vueThis.$store.state.shippingTabLevel = 3;
            }
            if (vueThis.$store.state.currentLevel >= 4) {
                vueThis.$store.state.currentLevel = 3;
            }
            vueThis.$helper.toggleAccordion(vueThis.$store.state.currentLevel);

            if (vueThis.$store.state.selectedShippingType === 'import') {
                if (vueThis.$store.state.packagesDimensions.length > 20) {
                    vueThis.$store.state.packagesDimensions.splice(20);
                }

                $.each(vueThis.$store.state.countriesList, function(index, element) {
                    if (element.country_code.toLowerCase() === 'lt'){
                        vueThis.$store.state.to.countryId = index;
                        vueThis.$store.state.to.countryBackgroundImage = element.backgroundImage;
                        vueThis.$store.state.to.countryName = element.title;
                        vueThis.$store.state.to.country = "lt";
                        return true;
                    }
                }); 
            } else {
                $.each(vueThis.$store.state.countriesList, function(index, element) {
                    if (element.country_code.toLowerCase() === 'lt') {
                        vueThis.$store.state.from.countryId = index;
                        vueThis.$store.state.from.countryBackgroundImage = element.backgroundImage;
                        vueThis.$store.state.from.countryName = element.title;
                        vueThis.$store.state.from.country = "lt";
                        return true;
                    }
                }); 
            }
            vueThis.$store.state.awaitingActions.reselectCountries.from = true;
            vueThis.$store.state.awaitingActions.reselectCountries.to = true;

            vueThis.$store.state.differentPaymentInformation.payer = 'sender';

            let shipperAddress = vueThis.$store.state.shipperAddressInformation;
            vueThis.$store.state.shipperAddressInformation = vueThis.$store.state.deliveryAddressInformation;
            vueThis.$store.state.deliveryAddressInformation = shipperAddress;
        }
    },
}
</script>
